import {
    FETCH_PRACTICES_REQUEST,
    FETCH_PRACTICES_RESULT,
    FETCH_PRACTICE_REQUEST,
    GET_ALL_PIMS,
    GET_ALL_PRACTICES,
    GET_ALL_SHARD_REGIONS,
    GET_CURRENT_PAGE,
    GET_FIRST_ACTIVE_PRACTICE_ID,
    GET_FIRST_STALE_PRACTICE_ID,
    GET_PRACTICE,
    GET_PRACTICE_CONFIG,
    GET_PRACTICE_CONFIG_FORM,
    GET_SOME_PRACTICES,
    GET_LATEST_RUNTIME_EXTRACTION,
    GET_LATEST_RUNTIME_STAGING,
    GET_LATEST_RUNTIME_INTERMEDIATE,
    GET_LATEST_RUNTIME_INSTANCE_REPORT,
    GET_LATEST_RUNTIME_CONVERSIONPREP,
    GET_LATEST_RUNTIME_LEADS_GENERATION,
    PRACTICES_WITH_NOTIFICATIONS,
    PRACTICE_ERROR,
    PRACTICE_TAB_SELECTED,
    PRACTICE_TO_MUTE,
    USER_ASSIGNING_PRACTICE,
    SEARCHING_FOR_PRACTICES,
    SELECT_PRACTICE,
    SET_ACTIVE_TAB_PRACTICES,
    SET_BOOKMARKED,
    SET_CURRENT_PAGE,
    SET_DASHBOARD_STATS,
    SET_FILTER,
    SET_FIRST_ACTIVE_PRACTICE_ID,
    SET_FIRST_PRACTICE_READY,
    SET_FIRST_STALE_PRACTICE_ID,
    SET_INCLUDE_TEST_PRACTICES,
    SET_INCLUDE_DORMANT_PRACTICES,
    SET_PRACTICE_NOTIFICATIONS,
    SET_SEARCH_ASSIGNED_PRACTICES,
    SET_SEARCH_COMMUNICATIONS,
    SET_SEARCH_GROUPS,
    SET_SEARCH_NOTES,
    SET_TOTAL_PAGES,
    UNSELECT_PRACTICE,
    SET_ASSIGNED_USER,
    SET_SEARCH_CUSTOM_IDS,
    SET_SEARCH_PARTNER_OFFERINGS,
    SET_SEARCH_PRACTICE_PIMS,
    SET_INTERMEDIATE_ENTITY_COUNTS,
    SET_PRACTICE_ID,
    SET_RELATION_STEP2,
    REMOVE_RELATION_STEP2,
    UPDATE_PRACTICE_TAB,
    RESET_RELATION_STEP2,
    SET_SCHEDULE_MODAL_WORKING_PRACTICE,
    SET_RELATIONS_MODAL_WORKING_PRACTICE,
    SET_CONFIG_MODAL_WORKING_PRACTICE,
    SET_PRACTICE_GROUPS,
    //FETCH_ALL_PRACTICES_RESULT,
    //FETCH_ALL_PRACTICES_REQUEST,
} from '../ActionTypes';

const initialState = {
    //searching parameters
    allPims: [],
    allShardRegions: [],
    assignedFilterUser: null,
    bookmarked: false,
    configurationData: {},
    configurationForm: {},
    currentPage: 1,
    dashboardInfo: {},
    error: '',
    filter: '',
    firstActivePractice: '',
    firstPractice: '',
    firstPracticeReady: false,
    firstStalePractice: '',
    isAllPracticesLoading: true,
    includeTestPractices: false,
    includeDormantPractices: false,
    intermediateEntityCounts: [],
    isPracticeLoading: true,
    onlyShowAssigned: false,
    practice: {},
    practiceGroups: [],
    practiceLink: 'all',
    practiceNotifications: 0,
    practiceToMute: {
        id: '',
        name: '',
        practiceMute: { muteUntil: 0, muteNote: null },
    },
    userAssigningModalPractice: {
        id: '',
        name: '',
        assignedAccountId: '',
        isAssignedToCurrentUser: false,
    },
    practices: [],
    practiceStep1: {},
    relationsStep2: [],
    latestRuntimeExtraction: '',
    latestRuntimeStaging: '',
    latestRuntimeIntermediate: '',
    latestRuntimeInstanceReport: '',
    latestRuntimeLeadsGeneration: '',
    currentPracticeId: '',
    searchGroups: false,
    searchNotes: false,
    searchCustomIds: false,
    searchPartnerOfferings: false,
    searchPracticePims: false,
    searchingForPractices: false,
    selectedPracticeTab: 0,
    selectedPracticeTabs: [],
    somePractices: [],
    totalPages: 1,
    practiceSheduleModalWorkingPractice: { nextSyncDate: '', id: '' },
    practiceRelationsModalWorkingPractice: {},
    practiceConfigModalWorkingPracticeId: '',
};

const practiceReduction = (state = initialState, action) => {
    switch (action.type) {
        case PRACTICE_TAB_SELECTED: {
            return {
                ...state,
                selectedPracticeTab: action.payload,
            };
        }
        case UNSELECT_PRACTICE: {
            if (!action.payload.practice) {
                return {
                    ...state,
                    selectedPracticeTabs: state.selectedPracticeTabs.filter(
                        (t) => t !== undefined
                    ),
                };
            }
            let selectedPractices = state.selectedPracticeTabs.filter(
                (tabs) => tabs.id !== action.payload.practice.id
            );
            let selectedTabId = state.selectedPracticeTab;
            if (action.payload.tabId === -1)
                action.payload.tabId = state.selectedPracticeTab;
            //tab lower than us
            if (action.payload.tabId < selectedTabId) {
                selectedTabId = selectedTabId - 1;
            } else if (action.payload.tabId === selectedTabId) {
                if (action.payload.tabId >= selectedPractices.length)
                    selectedTabId = selectedTabId - 1;
            }

            return {
                ...state,
                selectedPracticeTabs: selectedPractices,
                selectedPracticeTab: selectedTabId,
            };
        }
        case SELECT_PRACTICE: {
            let selectedTab = state.selectedPracticeTab;
            let alreadySelected = state.selectedPracticeTabs.filter(
                (tabs, index) => {
                    if (tabs?.id === action.payload.id) {
                        selectedTab = index;
                        return true;
                    }
                    return false;
                }
            );

            // if already selected and we clicked it on the sidebar, then change to it's tab.
            if ((alreadySelected || []).length > 0) {
                if (selectedTab === state.selectedPracticeTab) {
                    return state;
                } else {
                    return {
                        ...state,
                        selectedPracticeTab: selectedTab,
                    };
                }
            }

            let selectedPracticeTabs = state.selectedPracticeTabs.map(
                (tabs) => tabs
            );
            selectedPracticeTabs.push(action.payload);
            selectedTab = selectedPracticeTabs.length - 1;

            return {
                ...state,
                selectedPracticeTabs: selectedPracticeTabs,
                selectedPracticeTab: selectedTab,
            };
        }
        case SET_BOOKMARKED:
            return {
                ...state,
                bookmarked: action.payload,
            };
        case FETCH_PRACTICES_REQUEST:
            return {
                ...state,
                isAllPracticesLoading: true,
            };
        case FETCH_PRACTICES_RESULT:
            let practices = action.payload.practices || [];
            return {
                ...state,
                isAllPracticesLoading: false,
                practices: practices,
                totalPages: action.payload.totalPages,
                practiceLink: action.payload.practiceTab,
            };
        case SET_ACTIVE_TAB_PRACTICES:
            return {
                ...state,
                practiceLink: action.payload,
            };
        case FETCH_PRACTICE_REQUEST:
            return {
                ...state,
                isPracticeLoading: true,
            };
        case GET_ALL_PRACTICES:
            return {
                ...state,
                allPractices: action.payload,
                isAllPracticesLoading: false,
            };
        case GET_PRACTICE:
            return {
                ...state,
                practice: action.payload,
                isPracticeLoading: false,
                error: '',
            };
        case PRACTICE_ERROR:
            return {
                ...state,
                isPracticeLoading: false,
                error: action.payload,
            };
        case GET_SOME_PRACTICES:
            return {
                ...state,
                somePractices: action.payload,
            };
        case GET_LATEST_RUNTIME_EXTRACTION:
            return {
                ...state,
                latestRuntimeExtraction: action.payload,
            };
        case GET_LATEST_RUNTIME_STAGING:
            return {
                ...state,
                latestRuntimeStaging: action.payload,
            };
        case GET_LATEST_RUNTIME_INTERMEDIATE:
            return {
                ...state,
                latestRuntimeIntermediate: action.payload,
            };
        case GET_LATEST_RUNTIME_INSTANCE_REPORT:
            return {
                ...state,
                latestRuntimeInstanceReport: action.payload,
            };
        case GET_LATEST_RUNTIME_CONVERSIONPREP:
            return {
                ...state,
                latestRuntimeConversionPrep: action.payload,
            };
        case GET_LATEST_RUNTIME_LEADS_GENERATION:
            return {
                ...state,
                latestRuntimeLeadsGeneration: action.payload,
            };
        // case GET_FIRST_PRACTICE:
        //   return {
        //     ...state,
        //     firstPracticeReady: true,
        //     firstPractice: action.payload
        //   };
        case SET_FIRST_PRACTICE_READY:
            return {
                ...state,
                firstPracticeReady: action.payload,
            };
        case GET_ALL_PIMS:
            return {
                ...state,
                allPims: action.payload,
            };
        case GET_ALL_SHARD_REGIONS:
            return {
                ...state,
                allShardRegions: action.payload,
            };
        case GET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload,
            };
        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload,
            };
        case SET_FILTER:
            return {
                ...state,
                filter: action.payload,
            };
        case SET_TOTAL_PAGES:
            return {
                ...state,
                totalPages: action.payload,
            };
        // case GET_TOTAL_PAGES:
        //   return{
        //     ...state,
        //     totalPages: action.payload
        //   }
        case SET_FIRST_ACTIVE_PRACTICE_ID:
            return {
                ...state,
                firstActivePractice: action.payload,
            };
        case GET_FIRST_ACTIVE_PRACTICE_ID:
            return {
                ...state,
                firstActivePractice: action.payload,
            };
        case SET_FIRST_STALE_PRACTICE_ID:
            return {
                ...state,
                firstStalePractice: action.payload,
            };
        case GET_FIRST_STALE_PRACTICE_ID:
            return {
                ...state,
                firstStalePractice: action.payload,
            };
        case GET_PRACTICE_CONFIG:
            return {
                ...state,
                configurationData: action.payload,
            };
        case GET_PRACTICE_CONFIG_FORM:
            return {
                ...state,
                configurationForm: action.payload,
            };
        case PRACTICE_TO_MUTE:
            return {
                ...state,
                practiceToMute: action.payload,
            };
        case USER_ASSIGNING_PRACTICE:
            return {
                ...state,
                userAssigningModalPractice: action.payload,
            };
        case SEARCHING_FOR_PRACTICES:
            return {
                ...state,
                searchingForPractices: action.payload,
            };
        case SET_SEARCH_NOTES:
            return {
                ...state,
                searchNotes: action.payload,
            };
        case SET_PRACTICE_NOTIFICATIONS:
            return {
                ...state,
                practiceNotifications: action.payload,
            };
        case SET_SEARCH_ASSIGNED_PRACTICES:
            return {
                ...state,
                onlyShowAssigned: action.payload,
            };
        case SET_PRACTICE_GROUPS:
            return {
                ...state,
                practiceGroups: action.payload,
            };
        case SET_SEARCH_GROUPS:
            return {
                ...state,
                searchGroups: action.payload,
            };
        case SET_DASHBOARD_STATS:
            return {
                ...state,
                dashboardInfo: action.payload,
            };
        case SET_INCLUDE_TEST_PRACTICES:
            return {
                ...state,
                includeTestPractices: action.payload,
            };
        case SET_INCLUDE_DORMANT_PRACTICES:
            return {
                ...state,
                includeDormantPractices: action.payload,
            }
        case SET_ASSIGNED_USER:
            return {
                ...state,
                assignedFilterUser: action.payload,
            };
        case SET_SEARCH_CUSTOM_IDS:
            return {
                ...state,
                searchCustomIds: action.payload,
            };
        case SET_SEARCH_PARTNER_OFFERINGS:
            return {
                ...state,
                searchPartnerOfferings: action.payload,
            };
        case SET_SEARCH_PRACTICE_PIMS:
            return {
                ...state,
                searchPracticePims: action.payload,
            };
        case SET_INTERMEDIATE_ENTITY_COUNTS:
            return {
                ...state,
                intermediateEntityCounts: action.payload,
            };
        case SET_PRACTICE_ID:
            return {
                ...state,
                currentPracticeId: action.payload,
            };
        case SET_SCHEDULE_MODAL_WORKING_PRACTICE:
            return {
                ...state,
                practiceSheduleModalWorkingPractice: action.payload,
            };
        case SET_RELATIONS_MODAL_WORKING_PRACTICE:
            return {
                ...state,
                practiceRelationsModalWorkingPractice: action.payload,
            };
        case SET_CONFIG_MODAL_WORKING_PRACTICE:
            return {
                ...state,
                practiceConfigModalWorkingPracticeId: action.payload,
            };
        //#region Create New Practice Reducers
        case SET_RELATION_STEP2:
            let offerings = action.payload;

            let filteredOffering = state.relationsStep2.filter(
                (offer) =>
                    offer.partnerOfferingId !== action.payload.partnerOfferingId
            );

            return {
                ...state,
                relationsStep2: [...filteredOffering, { ...offerings }],
            };
        // TODO: this is not pure
        case REMOVE_RELATION_STEP2:
            return {
                ...state,
                relationsStep2: state.relationsStep2.filter(
                    (item) => item.partnerOfferingId !== action.payload
                ),
            };
        case RESET_RELATION_STEP2:
            return {
                ...state,
                relationsStep2: action.payload,
            };
        //#endregion
        case UPDATE_PRACTICE_TAB:
            let practiceTabs = state.selectedPracticeTabs.map((practice) => {
                if (practice?.id === action.payload.id) {
                    practice = action.payload;
                }
                return practice;
            });
            return {
                ...state,
                selectedPracticeTabs: practiceTabs,
            };
        default:
            return state;
    }
};

export default practiceReduction;
